<template>
  <v-main class="page-survey">
    <AppBar title="만족도 평가" />
    <v-layout fill-height column>
      <v-container class="pb-0" fluid>
        <div class="account-title-block">
          <h3 class="tit">
            <span class="tit-point">애니핏프로(PRO)</span> 마음건강관리서비스
          </h3>
          <p class="desc" style="word-break: keep-all">
            애니핏 프로(PRO)마음건강관리 서비스를 사용해 주셔서 감사합니다.<br />
            세 달간 마음건강관리 집중관리 서비스를 이용해 주신 분들을 대상으로 만족도 조사 설문을 요청 드립니다.<br />
            더 나은 서비스 제공을 위해 만족도 설문에 참여해 주시면 감사하겠습니다.
          </p>
        </div>
      </v-container>
      <hr class="hr">
      <v-form v-model="valid">
        <v-container fluid>
          <div v-for="(ques, i) in survey.surveyQuestionResults"
               :key="`question_${i}`"
               class="ques-item">
            <h5 class="ques-item-title">
              <strong>{{ 10 > (i + 1) ? '0' : '' }}{{ i + 1 }}.</strong>
              {{ ques.question }}
            </h5>
            <div class="ques-item-form">
              <!-- 라디오 && 체크박스 -->
              <template v-if="ques.questionTypeCode.includes('CHOICE')">
                <v-checkbox v-for="(option, f) in ques.surveyQuestionItemResults"
                            v-model="evaluationValues[i]"
                            :multiple="ques.questionTypeCode === 'MULTI_CHOICE'"
                            :hide-details="ques.surveyQuestionItemResults.length > (f + 1)"
                            :label="option.itemContents"
                            :key="`option_${i}_${f}`"
                            :value="option.evaluationValue"
                            :rules="[rules.required]"
                            @change="changeActive($event, ques.surveyQuestionId)"
                />
              </template>
              <!-- 짧은글 -->
              <template v-else-if="ques.questionTypeCode === 'ANSWERS' && ques.answerLengthTypeCode === 'SHORT'">
                <v-text-field solo dense outlined flat
                              v-model.trim="answers[i]"
                              :rules="rulesSetting(ques)"
                              :disabled="ques.active"
                />
              </template>
              <!-- 긴글 -->
              <template v-else-if="ques.questionTypeCode === 'ANSWERS' && ques.answerLengthTypeCode === 'LONG'">
                <v-textarea solo dense outlined flat
                            no-resize rows="5"
                            v-model.trim="answers[i]"
                            :rules="[rules.required, rules.trim, rules.length(ques.answerLength)]"
                />
              </template>
            </div>
          </div>
          <br />
          <v-btn x-large block depressed :ripple="false" color="primary"
                 :disabled="!valid" @click="saveSurveyAnswer"
          >제출</v-btn>
        </v-container>
      </v-form>
    </v-layout>
  </v-main>
</template>

<script>
import store from '@/store'

export default {
  name: 'SurveyIndex',
  data: () => ({
    valid: false,
    rules: {
      required: v => (!!v && v.length !== 0) || '필수 값입니다.',
      trim: v => (!!v && v.trim() !== '') || '공백만 작성 할 수 없습니다.',
      length: len => v => (v || '').length <= len || `${len}자 미만으로 작성 할 수 있습니다.`
    },
    survey: {
      surveyQuestionResults: [{
        surveyQuestionId: '',
        questionTypeCode: '',
        answerLengthTypeCode: '',
        surveyQuestionItemResults: [{
          itemContents: '',
          evaluationValue: '',
          answerLength: ''
        }]
      }],
      // 활성화 질문
      activeSurveyQuestionResults: [{
        surveyQuestionId: '',
        activeSurveyQuestionIds: ''
      }]
    },
    surveyAnswers: [],
    evaluationValues: [], // 객관식 답변
    answers: [] // 주관식 답변
  }),
  created() {
    this.getSurvey()
  },
  methods: {
    async getSurvey() {
      await store.dispatch('getSurvey', this.$_payload('surveySo', [{clientNo: store.getters.clientCd}]))
          .then(res => {
            if (res.success) {
              this.survey = res.data
            }
          }).catch(error => {
            console.error(error)
          })
          .finally(() => {
          })
    },
    changeActive(event, surveyQuestionId) {
      if (typeof event === 'number') {
        let activeSurveyQuestionIds = this.survey.surveyQuestionResults[surveyQuestionId - 1].surveyQuestionItemResults[event - 1].activeSurveyQuestionIds
        if (activeSurveyQuestionIds !== null) {
          activeSurveyQuestionIds.split(',').forEach((activeSurveyQuestionId) => {
            this.survey.surveyQuestionResults[activeSurveyQuestionId - 1].active = false
          })
        } else {
          this.survey.activeSurveyQuestionResults.forEach((activeSurveyQuestion) => {
            if (activeSurveyQuestion.surveyQuestionId === surveyQuestionId) {
              activeSurveyQuestion.activeSurveyQuestionIds.split(',').forEach((activeSurveyQuestionId) => {
                this.survey.surveyQuestionResults[activeSurveyQuestionId - 1].active = true
                delete this.answers[activeSurveyQuestionId - 1]
              })
            }
          })
        }
      }
    },
    rulesSetting(ques) {
      if (!ques.active) {
        return [this.rules.required, this.rules.trim, this.rules.length(ques.answerLength)]
      } else {
        return []
      }
    },
    async saveSurveyAnswer() {
      // 객관식
      this.evaluationValues.forEach((evaluationValue, index) => {
        // 단일
        if (typeof evaluationValue === 'number') {
          let params = {
            surveyQuestionId: index + 1,
            surveyQuestionItemId: this.survey.surveyQuestionResults[index].surveyQuestionItemResults[evaluationValue - 1].surveyQuestionItemId,
            evaluationValue: evaluationValue
          }
          this.surveyAnswers.push(params);
        }
        // 중복
        if (typeof evaluationValue === 'object') {
          evaluationValue.sort().forEach((item) => {
            let params = {
              surveyQuestionId: index + 1,
              surveyQuestionItemId: this.survey.surveyQuestionResults[index].surveyQuestionItemResults[item - 1].surveyQuestionItemId,
              evaluationValue: item
            }
            this.surveyAnswers.push(params);
          })
        }
      })
      // 주관식
      this.answers.forEach((answer, index) => {
        let params = {
          answer: answer,
          surveyQuestionId: index + 1
        }
        this.surveyAnswers.push(params);
      })

      this.surveyAnswers.sort((a, b) => a.surveyQuestionId - b.surveyQuestionId)
      await store.dispatch('saveSurveyAnswer', this.$_payload('surveyUserAnswerPos', this.surveyAnswers))
          .then(res => {
            if (res.success) {
              this.movePage('/')
            }
          }).catch(error => {
            console.error(error)
          })
          .finally(() => {
          })
    }
  }
}
</script>

<style lang="scss" src="@/assets/sass/page/_survey.scss"></style>
